<template>
  <div class="balance">
   <div class="balance_tit">
     余额
   </div>
   <div class="balance_box">
        <div class="balance_pay" @click="balancepage">
          <div class="balance_left">
            <div class="balance_pay_tit">
              当前店铺余额（元）
            </div>
            <div class="balance_price">
              {{medata.money}}
            </div>
          </div>
          <img src="../../../assets/balance_img.png" alt="" srcset="">
        </div>
   </div>
  </div>
</template>

<script>

  import {getpersonageapi} from "../../../api/http.js"
  export default{
   name:"balance",
    data(){
      return{
        medata:[]
      }
    },
   async created() {
      const res = await getpersonageapi()
      console.log(res.data.data);
      if(res.data.code == 200){
        this.medata =res.data.data
      }
    },
    methods:{
      balancepage(){
        this.$router.push({
          path:"/layout/balancepay"
        })
      }
    }
  }
</script>

<style lang="less">
.balance{
  width: 100%;
  .balance_tit{
    width: 100%;
    height: 40px;
    line-height: 40px;
    color: #292929;
    margin-bottom: 20px;
  }
  .balance_box{
    padding: 33px 22px;
    width: 100%;
    height: 260px;
    border: 1px solid #CCCDCE;
    .balance_pay{
      width: 382px;
      height: 137px;
      color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: linear-gradient(90deg, #EC5D89 0%, #EA5551 100%);
      border-radius: 10px;
      .balance_left{
        height: 100%;
        padding: 35px;
        box-sizing: border-box;
        .balance_pay_tit{
          margin-bottom: 20px;
        }
        .balance_price{}
      }
      img{
        margin-right: 20px;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/view/balance.vue